import React, { useState } from 'react';
import { Tabs, Tab, Container } from 'react-bootstrap';
import { Link, useNavigate } from 'react-router-dom';

import Slider from 'react-slick';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import { FaAngleLeft, FaAngleRight } from "react-icons/fa";

import bulb1 from "../images/led2.jpg";
import bulb2 from "../images/downlight.jpg";
import bulb3 from "../images/panel-light.jpg";
import bulb4 from "../images/adju.jpeg";
import bulb10 from "../images/8.jpg";
import bulb7 from "../images/cob.jpeg";
import bulb8 from "../images/batten1.jpg";
import bulb9 from "../images/tube-ligh1.jpg";

import spotlight from "../images/spot-light.jpg";
import floodlight from "../images/flood.jpg";
import streetlight from "../images/street-light.jpg";
import HighbayLights from "../images/high-bay.jpg";
import tseriess from "../images/tseriess-light.jpg";
import tubelig from "../images/tube-light.jpg";
import stadium from "../images/stadium-light.jpg";
import solar from "../images/solar.jpg";

const imageData = {
  consumer: [
    { id: 2, img: bulb1, title: 'LED Downlights' },
    { id: 3, img: bulb2, title: 'LED Slim Panel Lights' },
    { id: 4, img: bulb3, title: 'LED Adjustable Panel Lights' },
    { id: 5, img: bulb4, title: 'LED Adjustable Panel Lights' },
    { id: 6, img: bulb10, title: 'LED Surface Panel' },
    { id: 7, img: bulb7, title: 'LED COB' },
    { id: 8, img: bulb8, title: 'LED Batten Light' },
    { id: 9, img: bulb9, title: 'LED Tube Light' }
  ],
  professional: [
    { id: 15, img: spotlight, title: 'Spot Lights' },
    { id: 11, img: floodlight, title: 'Flood Lights' },
    { id: 10, img: streetlight, title: 'Street Light' },
    { id: 13, img: HighbayLights, title: 'High bay Lights' },
    { id: 14, img: tseriess, title: 'LED T Series Bulbs' },
    { id: 16, img: tubelig, title: 'LED Tube Light' },
    { id: 17, img: stadium, title: 'LED Stadium Light' },
    { id: 18, img: solar, title: 'LED Solar Street Lights' }
  ],
  pcb: [],
  // "sma rt Lighting": []
};

// Custom Arrow Components
const PrevArrow = ({ onClick }) => (
  <div className="custom-arrow left" onClick={onClick}>
    <FaAngleLeft />
  </div>
);

const NextArrow = ({ onClick }) => (
  <div className="custom-arrow right" onClick={onClick}>
    <FaAngleRight />
  </div>
);

const ImageSliderTabs = () => {
  const [activeTab, setActiveTab] = useState('consumer');
  const navigate = useNavigate();

  const handleTabSelect = (key) => {
    setActiveTab(key);
    if (key === 'pcb') {
      navigate('/Ourproduct');
    }
  };

  const sliderSettings = {
    centerMode: true,
    centerPadding: '60px',
    slidesToShow: 3,
    infinite: true,
    speed: 600,
    arrows: true,
    nextArrow: <NextArrow />,
    prevArrow: <PrevArrow />,
    responsive: [
      {
        breakpoint: 768,
        settings: {
          arrows: true,
          centerMode: true,
          centerPadding: '40px',
          slidesToShow: 2
        }
      },
      {
        breakpoint: 480,
        settings: {
          arrows: true,
          centerMode: true,
          centerPadding: '20px',
          slidesToShow: 1
        }
      }
    ]
  };

  return (
    <Container className="my-5 tabs-slider-wrapper mt-5">
      <h2 className="text-center mb-5">Product Categories</h2>
      <Tabs
        activeKey={activeTab}
        onSelect={handleTabSelect}
        className="mb-5 justify-content-center custom-tabs"
      >
        {Object.entries(imageData).map(([key, images]) => (
          <Tab eventKey={key} title={key.charAt(0).toUpperCase() + key.slice(1)} key={key}>
            {images.length > 0 ? (
              <Slider {...sliderSettings}>
                {images.map((item, idx) => (
                  <div key={idx} className="slider-card">
                    <Link to={`/ProductList/${item.id}`} style={{ color: "black", textDecoration: "none" }}>
                      <div className="card-inner">
                        <img src={`${item.img}`} alt={item.title} />
                        <h5>{item.title}</h5>
                      </div>
                    </Link>
                  </div>
                ))}
              </Slider>
            ) : key !== 'pcb' ? (
              <p style={{ padding: "20px", textAlign: "center", color: "red" }}>
                Data not found
              </p>
            ) : null}
          </Tab>
        ))}
      </Tabs>
    </Container>
  );
};

export default ImageSliderTabs;
